import React from 'react';
import './Experience.css';

const Experience = () => {
  const experiences = [
    {
      company: 'iCog Labs',
      position: 'AI Engineer',
      period: 'Present',
      description: 'Building Agentic Systems using tools like LangGraph, MCP, and Large Language Models (LLMs), and deployment processes. Currently focusing on integrating advanced agentic systems with bioinformatics.',
      responsibilities: [
        'AI Research',
        'Ai Engineer',
        'Software Development'
      ]
    },
    {
      company: 'iCog Labs',
      position: 'Intern',
      period: '2025',
      description: 'Worked as an intern at iCog Labs, an Ethiopian AI and robotics research company. Contributing to ML, symbolic systems, agentic RAG, and domain-specific LLM fine-tuning with LoRA/QLoRA.',
      responsibilities: [
        'Machine Learning',
        'Software Development',
        'Educational Initiatives'
      ]
    },
    {
      company: 'Kifiya 10 Academy',
      position: 'AI Mastery Trainee',
      period: '2024',
      description: 'Participated in an intensive AI training program focusing on practical implementation of machine learning solutions and financial analytics.',
      responsibilities: [
        'Developed and deployed machine learning models for real-world applications',
        'Implemented data collection and preprocessing pipelines',
        'Applied explainability techniques (SHAP) for model interpretation',
        'Collaborated with team members on various AI projects',
        'Presented technical findings to stakeholders'
      ],
    },
    {
      company: 'Freelancer',
      position: 'Independent Developer',
      period: 'Since 2023',
      description: 'Provide freelance services specializing in web development, machine learning, and artificial intelligence. Projects include creating responsive websites, training machine learning models, and developing AI solutions tailored to client needs.',
      responsibilities: [
        'Web Development & Responsive Design',
        'Machine Learning Model Development',
        'AI Solution Implementation'
      ],
    }
  ];

  return (
    <div className="experience">
      <h2 className="section-title">Experience</h2>
      {experiences.map((experience, index) => (
        <div className="experience-card" key={index}>
          <div className="experience-header">
            <h3>{experience.position}</h3>
            <span className="company">{experience.company}</span>
            <span className="duration">{experience.period}</span>
          </div>
          <div className="experience-content">
            <p>{experience.description}</p>
            <ul className="achievements">
              {experience.responsibilities.map((responsibility, index) => (
                <li key={index}>{responsibility}</li>
              ))}
            </ul>
            {experience.techUsed && (
              <div className="tech-used">
                {experience.techUsed.map((tech, index) => (
                  <span key={index}>{tech}</span>
                ))}
              </div>
            )}
            {experience.upworkProfile && (
              <div className="upwork-profile">
                <a href={experience.upworkProfile} target="_blank" rel="noopener noreferrer">View Upwork Profile</a>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Experience;
